import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {loginFeatureKey, State} from '../../auth/login/reducers/login.reducer';
import {Store} from '@ngrx/store';
import {AppState} from '../../reducers';
import {LogoutUser} from '../../auth/login/actions/login.actions';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DashboardService} from '../../dashboard/dashboard.service';
import {notificationsFeatureKey} from '../../reducers/notification/notification.reducer';
import {getNotifications, getNotificationsSimple} from '../../reducers/notification/notification.actions';
import { cookies } from '../cookies/accept-terms-mobile.component';
import { MatDialog } from '@angular/material/dialog';
import {MessageService} from 'primeng/api';
import {SubscriptionDialogComponent} from '../../payment/subscription-dialog.component';
import {AuthenticateService} from '../../auth/authenticate.service';
import {Router} from '@angular/router';
import {NbDialogService} from '@nebular/theme';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import {LanguageService} from '../../services/language.service';
import {CurrencyService} from '../../services/currency.service';
import {TranslateService} from '@ngx-translate/core';
import {LocaleService} from '../../services/locale.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [MessageService]
})
export class HeaderComponent implements OnInit {

    @Input() user: State;
    @Output() onMenuClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
    login$: Observable<any>;
    notifications$: Observable<any[]>;
    currentLanguage: string;
    currentCurrency: string;

    constructor(private store: Store<AppState>,
                private dashboardService: DashboardService,
                private dialog: MatDialog,
                private messageService: MessageService,
                // private authService: AuthenticateService,
                private router: Router,
                public dialogService: NbDialogService,
                public languageService: LanguageService,
                public currencyService: CurrencyService,
                private translate: TranslateService,
                public localeService: LocaleService) {
    }

    onMenuClick($event) {
        this.onMenuClicked.emit($event);
    }

  isCalculateRoute(): boolean {
    return this.router.url === '/account/calculate';
  }

  get isUAERoute(): boolean {
    return this.router.url.startsWith('/uae') || this.router.url.startsWith('/ga') || this.router.url.startsWith('/nigeria');
  }

  // Currency selector is shown only on the orders list (incl. ?f=draft / other
  // filters), not the single-order view or any other page.
  get isOrdersListRoute(): boolean {
    return this.router.url.split('?')[0].split('#')[0] === '/account/orders';
  }

  get isNigeriaRoute(): boolean {
    return this.router.url.startsWith('/nigeria');
  }

    ngOnInit(): void {
        this.currentLanguage = this.languageService.getCurrentLanguage();
        this.currencyService.ensureLoaded();
        this.currencyService.preferred$.subscribe(c => this.currentCurrency = c);

        this.translate.onLangChange.subscribe((event) => {
            this.currentLanguage = event.lang;
        });
        
        this.login$ = this.store.select(state => state[loginFeatureKey]).pipe(map((ls: any) => {
            if (ls.isLogin) {
                this.currencyService.ensureLoaded();
                this.currencyService.syncFromServer();
                // this.handleSubscription();
                this.updateNotifications();
                this.notificationsListener();
            }
            return ls.isLogin;
        }));
    }

    logout($event) {
        this.store.dispatch(LogoutUser());
    }

    updateNotifications() {
        this.notifications$ = this.store.select(state => state[notificationsFeatureKey]).pipe(map(s => {
            if (!s.loaded || (Date.now() - (s.lastUpdate as number) > 10000)) {
                this.store.dispatch(getNotificationsSimple());
            }
            return Object.values(s.entities).filter(n => !n.seen);
        }));
    }

    notificationsListener() {
        setInterval(() => {
            this.updateNotifications();
        }, 60000);
    }
    openDialog() {

        const approve = this.dialog.open(cookies, {});
    }

  handleSubscription() {
    console.log('showMessage');
    if (this.user.userData
      && this.user.userData.cpms === 1
      && this.user.userData.cpmCount > 0) {
      this.showMessage();
      // this.messageService.add({
      //   severity: 'info', // Other options: success, error, warn
      //   summary: 'הודעת מערכת',
      //   detail: `נותרו ${this.user.userData.cpmCount} כניסות למערכת עבור חודש זה`,
      //   life: 5000,
      //   sticky: true
      // });
    }
    // else {
    //   // const data = await this.checkUserAuthentication();
    //   // console.log(data);
    //
    //   if (this.user.userData.cpms == 1 && !this.user.userData.allowCM) {
    //     // show dialog
    //     const dialogConfig = {
    //       hasBackdrop: true,
    //       closeOnEsc: true,
    //       backdropClass: '',
    //       closeOnBackdropClick: false,
    //       hasScroll: false,
    //       autoFocus: false,
    //       viewContainerRef: undefined,
    //     };
    //
    //     const dialogRef = this.dialogService.open(SubscriptionDialogComponent, dialogConfig);
    //
    //     dialogRef.onClose.subscribe((result: any) => {
    //       // this.nbDialogRef.close(data);
    //     });
    //     // const dialogRef = this.dialog.open(SubscriptionDialogComponent);
    //
    //     // after 2 seconds, close the dialog and navigate to /subscribe
    //     setTimeout(() => {
    //       dialogRef.close();
    //       this.router.navigate(['/subscribe']);
    //     }, 2000000);
    //   }
    // }
  }

  showMessage() {
    if (!this.isCalculateRoute()) {
      return;
    }
    const triesLeft = this.user.userData.cpmCount < 0 ? 0 : this.user.userData.cpmCount - 1;
    this.messageService.add({
      id: 'subscribe',
      severity: 'info', // Other options: success, error, warn
      summary: 'הודעת מערכת',
      detail: `נותרו ${triesLeft} ניסיונות חישוב למערכת עבור חודש זה, להירשם נא להקליק על`,
      // detail: `נותרו ${this.user.userData.cpmCount} כניסות למערכת עבור חודש זה`,
      life: 10000,
    });
  }

    // async checkUserAuthentication() {
    //   const userId = sessionStorage.getItem('user-id');
    //   // if (!userId) {
    //   const res: any = await this.authService.checkAuth().toPromise();
    //   if (res.code === 200) {
    //     sessionStorage.setItem('user-id', res.data.id);
    //     // Your dataLayer logic
    //     return res.data;
    //   }
    //   // }
    //   return null;
    // }

    switchLanguage(lang: string) {
        this.localeService.setChosenLanguage(lang);
    }

    switchCurrency(name: string) {
        this.currencyService.choose(name);
    }

    getCurrencyOptions(): string[] {
        return this.currencyService.options;
    }

    getCurrentLanguage(): string {
        return this.languageService.getCurrentLanguage();
    }

    getAvailableLanguages(): string[] {
        return this.languageService.getAvailableLanguages();
    }

    getLanguageDisplayName(lang: string): string {
        return this.languageService.getLanguageDisplayName(lang);
    }
}
